/* eslint-disable key-spacing */

/*
 * Take icons from https://material.io/icons/
 *
 * Use icon ids in underscore_format
 */
export default {
  segments: {

    categories: {
      'leisure.entertainment'     : 'local_activity',
      'leisure.shopping'          : 'shopping_cart',
      'leisure.wellbeing'         : 'fitness_center',
      'leisure.wining_and_dining' : 'restaurant_menu',
      'mobility.commute'          : 'transfer_within_a_station',
      'mobility.driving'          : 'directions_car',
      'mobility.transport'        : 'tram',
      'mobility.travel'           : 'airplanemode_active',
      'other.geography'           : 'public',
      'work_life.family'          : 'wc',
      'work_life.home'            : 'home',
      'work_life.social'          : 'group',
      'work_life.work'            : 'work',
    },

    ids: {
      'leisure.entertainment.bar_goer'                         : '',
      'leisure.entertainment.clubber'                          : '',
      'leisure.entertainment.culture_buff'                     : '',
      'leisure.entertainment.gamer'                            : '',
      'leisure.entertainment.music_lover'                      : '',
      'leisure.entertainment.nature_lover'                     : '',
      'leisure.shopping.beauty_queen'                          : '',
      'leisure.shopping.brand_loyal.retail'                    : '',
      'leisure.shopping.brand_loyalty'                         : '',
      'leisure.shopping.brand_loyalty.supermarket'             : '',
      'leisure.shopping.fashionista'                           : '',
      'leisure.shopping.foodie'                                : '',
      'leisure.shopping.shopaholic'                            : '',
      'leisure.wellbeing.healthy_biker'                        : '',
      'leisure.wellbeing.healthy_walker'                       : '',
      'leisure.wellbeing.physical_activity.high'               : '',
      'leisure.wellbeing.physical_activity.limited'            : '',
      'leisure.wellbeing.physical_activity.moderate'           : '',
      'leisure.wellbeing.sportive'                             : '',
      'leisure.wining_and_dining.brand_loyal.bar'              : '',
      'leisure.wining_and_dining.brand_loyal.cafe'             : '',
      'leisure.wining_and_dining.brand_loyal.restaurant'       : '',
      'leisure.wining_and_dining.brand_loyalty.restaurant_bar' : '',
      'leisure.wining_and_dining.resto_lover'                  : '',
      'leisure.wining_and_dining.resto_lover.american'         : '',
      'leisure.wining_and_dining.resto_lover.asian'            : '',
      'leisure.wining_and_dining.resto_lover.barbecue'         : '',
      'leisure.wining_and_dining.resto_lover.fastfood'         : '',
      'leisure.wining_and_dining.resto_lover.french'           : '',
      'leisure.wining_and_dining.resto_lover.german'           : '',
      'leisure.wining_and_dining.resto_lover.greek'            : '',
      'leisure.wining_and_dining.resto_lover.grill'            : '',
      'leisure.wining_and_dining.resto_lover.international'    : '',
      'leisure.wining_and_dining.resto_lover.italian'          : '',
      'leisure.wining_and_dining.resto_lover.mediterranean'    : '',
      'leisure.wining_and_dining.resto_lover.mexican'          : '',
      'leisure.wining_and_dining.resto_lover.seafood'          : '',
      'leisure.wining_and_dining.resto_lover.snack'            : '',
      'mobility.commute.easy_commuter'                         : '',
      'mobility.commute.green_commuter'                        : '',
      'mobility.commute.heavy_commuter'                        : '',
      'mobility.commute.long_commuter'                         : '',
      'mobility.commute.normal_commuter'                       : '',
      'mobility.commute.short_commuter'                        : '',
      'mobility.driving.aggressive_driver'                     : '',
      'mobility.driving.anticipative_driver'                   : '',
      'mobility.driving.brand_loyalty.gas_stations'            : '',
      'mobility.driving.city_driver'                           : '',
      'mobility.driving.die_hard_driver'                       : '',
      'mobility.driving.distracted_driver'                     : '',
      'mobility.driving.efficient_driver'                      : '',
      'mobility.driving.illegal_driver'                        : '',
      'mobility.driving.legal_driver'                          : '',
      'mobility.driving.motorway_driver'                       : '',
      'mobility.transport.mobility.high'                       : '',
      'mobility.transport.mobility.limited'                    : '',
      'mobility.transport.mobility.moderate'                   : '',
      'mobility.transport.public_transports_user'              : '',
      'mobility.travel.frequent_flyer'                         : 'flight',
      'other.geography.home.antwerp'                           : '',
      'other.geography.home.brussels'                          : '',
      'other.geography.home.ghent'                             : '',
      'other.geography.work.antwerp'                           : '',
      'other.geography.work.brussels'                          : '',
      'other.geography.work.ghent'                             : '',
      'work_life.family.uber_parent'                           : '',
      'work_life.home.city_home'                               : '',
      'work_life.home.do_it_yourselver'                        : '',
      'work_life.home.dog_walker'                              : '',
      'work_life.home.early_bird'                              : '',
      'work_life.home.home_bound'                              : '',
      'work_life.home.homebody'                                : '',
      'work_life.home.night_owl'                               : '',
      'work_life.home.pet_owner'                               : '',
      'work_life.home.recently_moved_home'                     : '',
      'work_life.home.rural_home'                              : '',
      'work_life.home.sleep_deprived'                          : '',
      'work_life.home.town_home'                               : '',
      'work_life.home.work_life_balance'                       : '',
      'work_life.social.social_activity.high'                  : '',
      'work_life.social.social_activity.limited'               : '',
      'work_life.social.social_activity.moderate'              : '',
      'work_life.work.city_worker'                             : '',
      'work_life.work.fulltime_worker'                         : '',
      'work_life.work.homeworker'                              : '',
      'work_life.work.late_worker'                             : '',
      'work_life.work.nightworker'                             : '',
      'work_life.work.parttime_worker'                         : '',
      'work_life.work.recently_changed_job'                    : '',
      'work_life.work.rural_worker'                            : '',
      'work_life.work.student'                                 : '',
      'work_life.work.town_worker'                             : '',
      'work_life.work.work_traveller'                          : '',
      'work_life.work.workaholic'                              : ''
    }

  },

  charts : {
    // personal location
    'home'              : 'home',
    'work'              : 'work',
    'other'             : 'place',
    'transport'         : 'near_me',

    // general locations
    'retail'            : 'store',
    'grocery'           : 'shopping_cart',
    'bar / restaurant'  : 'local_bar',
    'entertainment'     : 'movie_filter',

    // transport
    'car'               : 'directions_car',
    'walking'           : 'directions_walk',
    'biking'            : 'directions_bike',
    'train'             : 'train',
    'bus'               : 'directions_bus',
    'tram'              : 'tram',
    'subway'            : 'directions_subway',
    'boat'              : 'directions_boat',
    'motorcycle'        : 'motorcycle',
    'flight'            : 'flight',
    'running'           : 'directions_run',

    // time
    'morning'           : 'brightness_5',
    'afternoon'         : 'brightness_7',
    'evening'           : 'brightness_medium',
    'night'             : 'brightness_3'
  },

  notifications: {
    info    : 'info',
    warning : 'warning',
    error   : 'error',
    help    : 'help',
  }
}
